import { useEffect, useState } from "react";
import { apiGetUserAdminPermissions } from "@app/api";
import { AdminPermissions } from "@app/constants";

export function useAdminPermissions() {
  const [permissions, setPermissions] = useState<
    Partial<Record<AdminPermissions, boolean>>
  >({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchPermissions = async () => {
      try {
        const res = await apiGetUserAdminPermissions();
        if (mounted) {
          setPermissions(res.data?.data ?? {});
        }
      } catch (e) {
        console.error("Failed to fetch admin permissions", e);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchPermissions();
    return () => {
      mounted = false;
    };
  }, []);

  return { permissions, loading };
}
